// What the touch buttons should light up for (#67): the crouch charge for the
// ring around Ollie, a rail in reach for Grind, the revert window for Revert.
// Read from the skater each HUD tick; the special meter's glow comes from the
// HUD's `specialFull`. Kept to coarse values so the HUD only changes when the
// picture does.

import type { Skater } from "./skater";
import { railInReach } from "./sim/grind";
import { FULL_CHARGE } from "./sim/tuning";

export interface TouchHints {
  /** Crouch charge toward a full ollie, 0..1 in tenths; 0 unless crouching on the ground. */
  ollieCharge: number;
  /** A Grind press now would lock onto a rail. */
  grindReady: boolean;
  /** Inside the revert window after a ramp landing. */
  revertReady: boolean;
}

export function touchHints(sk: Skater): TouchHints {
  const charge =
    sk.mode === "ground" ? Math.min(1, sk.charge / FULL_CHARGE) : 0;
  return {
    ollieCharge: Math.round(charge * 10) / 10,
    grindReady: railInReach(sk),
    revertReady: sk.mode === "ground" && sk.revertWindow > 0,
  };
}
